<script setup lang="ts">
/**
 * « Donoor, c'est quoi ? » en bas des pages publiques d'association — charte
 * « apple » (Karim 2026-10-18) : un bloc graphite sobre (au lieu du jaune),
 * texte et bouton à gauche, les trois arguments à droite. Discret par
 * construction : la page reste celle de l'association.
 */
import { TITRE_SECTION_APPLE } from "~/utils/titresApple";

const { t } = useI18n();
// Garde gclid/utm jusqu'à l'inscription.
const registerLink = useRegisterLink();

const arguments_ = [
  { icone: "i-lucide-heart-handshake", cle: "argument1" },
  { icone: "i-lucide-zap", cle: "argument2" },
  { icone: "i-lucide-users", cle: "argument3" },
];
</script>

<template>
  <div class="mx-auto max-w-[1120px] px-4 pb-20 sm:px-8 lg:pb-28">
    <div class="pa-reveal relative overflow-hidden rounded-[32px] bg-[#1d1d1f] px-7 py-12 sm:px-12 lg:px-16 lg:py-16">
      <div class="relative grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <h2 class="mb-5 text-[32px] text-white sm:text-[40px]" :style="TITRE_SECTION_APPLE">
            {{ t("association.donoorCta.titre") }}
          </h2>
          <p class="mb-8 text-[17px] leading-[1.6] text-[#a1a1a6]">
            {{ t("association.donoorCta.texte") }}
          </p>
          <BoutonApple v-register-cta="'page-association'" :to="registerLink" variante="blanc">
            {{ t("association.donoorCta.bouton") }}
          </BoutonApple>
        </div>

        <ul class="space-y-7">
          <li v-for="a in arguments_" :key="a.cle" class="flex items-start gap-4">
            <span class="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-white/10">
              <UIcon :name="a.icone" class="size-5 text-white" aria-hidden="true" />
            </span>
            <div>
              <p class="mb-1 text-[17px] font-semibold text-white">{{ t(`association.donoorCta.${a.cle}Titre`) }}</p>
              <p class="text-[15px] leading-[1.55] text-[#a1a1a6]">{{ t(`association.donoorCta.${a.cle}Texte`) }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
